// Depoimentos REAIS de clientes (conversas WhatsApp, pedidos entregues — mai/jun 2026).
// Um depoimento por cliente, juntando mensagens consecutivas da mesma entrega.
// Texto levemente ajustado em pontuação/maiúsculas para leitura; emojis e voz preservados.
// Nomes podem ser trocados / autorizados depois (decisão de produto).
// Fonte única consumida por:
//   - src/pages/home/components/Testimonials.tsx (grid da home)
//   - src/pages/musica/components/TestimonialsCarousel.tsx (carrossel /musica-personalizada)

export type Testimonial = {
  id: number;
  name: string; // primeiro nome do cliente
  context: string; // "Pra filha Mirella · Gospel"
  initial: string; // letra do avatar
  hue: string; // cor do gradiente do avatar
  text: string;
  stars: number;
  highlight?: boolean; // depoimentos de maior impacto (destaque visual)
};

const HUES = ['#ff914d', '#cc6620', '#ffb07a', '#a04920'];
const hue = (i: number) => HUES[i % HUES.length];

// Ordenados com os de maior impacto primeiro (reação de quem recebeu + emoção forte).
export const testimonials: Testimonial[] = [
  {
    id: 1,
    name: 'Maiza',
    context: 'Pra filha Mirella · Gospel',
    initial: 'M',
    hue: hue(0),
    text: 'Ela me mandou mensagem chorando, dizendo que a música ficou linda e perguntando como eu tinha feito aquilo. Ela amou e ficou muito emocionada. 😭',
    stars: 5,
    highlight: true,
  },
  {
    id: 2,
    name: 'Danila',
    context: 'Pra mãe Cida · Gospel',
    initial: 'D',
    hue: hue(1),
    text: 'Nossa, muito obrigada, ficou linda. Estou muito emocionada, gratidão. ❤️',
    stars: 5,
    highlight: true,
  },
  {
    id: 3,
    name: 'Cida',
    context: 'Pra família · Gospel',
    initial: 'C',
    hue: hue(2),
    text: 'Elas se emocionaram muito, a Anaely chorou muito. Ficou lindo. 🥰',
    stars: 5,
    highlight: true,
  },
  {
    id: 4,
    name: 'Mirian',
    context: 'Homenagem ao Vital · Gospel',
    initial: 'M',
    hue: hue(3),
    text: 'Chorei tanto. Dia 12 vou colocar pra ele ouvir no carro. Muito obrigada, gratidão. 🙏',
    stars: 5,
    highlight: true,
  },
  {
    id: 5,
    name: 'Lia',
    context: 'Pro esposo Alexandre · Gospel',
    initial: 'L',
    hue: hue(4),
    text: 'Chorei. Deus abençoe, ficou linda. 😭',
    stars: 5,
    highlight: true,
  },
  {
    id: 6,
    name: 'Gerliani',
    context: 'Pros sobrinhos · Sertanejo',
    initial: 'G',
    hue: hue(5),
    text: 'Eu amei a música. Eu chorei. ❤️',
    stars: 5,
    highlight: true,
  },
  {
    id: 7,
    name: 'Valdirene',
    context: 'Pra mãe Luiza Helena · Gospel',
    initial: 'V',
    hue: hue(6),
    text: 'A minha mãe amou, se emocionou. Amei a música.',
    stars: 5,
    highlight: true,
  },
  {
    id: 8,
    name: 'Denilson',
    context: 'Pra esposa Ariadne · Sertanejo',
    initial: 'D',
    hue: hue(7),
    text: 'Ritmo, batida incrível. Tá aprovadíssimo. Amei! 🤩',
    stars: 5,
    highlight: true,
  },
  {
    id: 9,
    name: 'Roberto',
    context: 'Pra Liliana · MPB',
    initial: 'R',
    hue: hue(8),
    text: 'Perfeito, maravilha, ficou ótimo. E ela adorou! 🙏',
    stars: 5,
  },
  {
    id: 10,
    name: 'Zélia',
    context: 'Pra filha Priscila · Gospel',
    initial: 'Z',
    hue: hue(9),
    text: 'Adorei a música! Muito obrigada, Deus abençoe. Vou voltar mais vezes. 😊',
    stars: 5,
  },
  {
    id: 11,
    name: 'Aguida',
    context: 'Pro Ezequias · Sertanejo',
    initial: 'A',
    hue: hue(10),
    text: 'Amei! Seu trabalho é perfeito.',
    stars: 5,
  },
  {
    id: 12,
    name: 'Enilda',
    context: 'Pra filha Vivian · Gospel',
    initial: 'E',
    hue: hue(11),
    text: 'Ficou muito linda, estou chorando até agora. Eu adorei.',
    stars: 5,
  },
  {
    id: 14,
    name: 'Dina',
    context: 'Pra ela mesma · Sertanejo',
    initial: 'D',
    hue: hue(13),
    text: 'Olha, eu amei a minha música. Obrigada.',
    stars: 5,
  },
  {
    id: 15,
    name: 'Clair',
    context: 'Pra mãe Thaís · Sertanejo',
    initial: 'C',
    hue: hue(14),
    text: 'Amei, maravilhoso, obrigada.',
    stars: 5,
  },
  {
    id: 16,
    name: 'Mara',
    context: 'Homenagem ao Leandro · Sertanejo',
    initial: 'M',
    hue: hue(15),
    text: 'Muito lindo, amei, obrigado. 🙏',
    stars: 5,
  },
  {
    id: 17,
    name: 'Daniela',
    context: 'Pra Vandréa · Gospel',
    initial: 'D',
    hue: hue(16),
    text: 'Ficou linda... amei. Obrigada.',
    stars: 5,
  },
  {
    id: 18,
    name: 'Cleudes',
    context: 'Pra irmã Cleimar · Pagode',
    initial: 'C',
    hue: hue(17),
    text: 'Ela gostou muito! 🥰',
    stars: 5,
  },
  {
    id: 19,
    name: 'Leir',
    context: 'Pra mãe Eponina · Gospel',
    initial: 'L',
    hue: hue(18),
    text: 'Achei maravilhosa.',
    stars: 5,
  },
  {
    id: 20,
    name: 'Alessandro',
    context: 'Pra esposa Rejane · Gospel',
    initial: 'A',
    hue: hue(19),
    text: 'Maravilhoso, obrigado! 👏',
    stars: 5,
  },
  {
    id: 21,
    name: 'Veronica',
    context: 'Pra ela mesma · MPB',
    initial: 'V',
    hue: hue(20),
    text: 'Eu amei, ficou top!',
    stars: 5,
  },
  {
    id: 22,
    name: 'Ilda',
    context: 'Pro filho Anderson · Sertanejo Raiz',
    initial: 'I',
    hue: hue(21),
    text: 'Amei, gostei muito. As duas ficaram lindas.',
    stars: 5,
  },
  {
    id: 23,
    name: 'Vânia',
    context: 'Pra igreja · Gospel',
    initial: 'V',
    hue: hue(22),
    text: 'Ficou muito boa, amei! 👏',
    stars: 5,
  },
  {
    id: 24,
    name: 'Claudia',
    context: 'Pro Luciano · Rock',
    initial: 'C',
    hue: hue(23),
    text: 'Perfeita! 👏',
    stars: 5,
  },
  {
    id: 25,
    name: 'Alexandra',
    context: 'Música personalizada',
    initial: 'A',
    hue: hue(24),
    text: 'Ficou linda.',
    stars: 5,
  },
];
